import { publicEnv } from '@/lib/env';

export const getConnectDUPRURL = (
  userId: string,
  moduleFor: string = 'p',
  cancelUrl?: string,
  successUrl?: string
) => {
  const url = new URL(
    `https://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}/failed-membership?org=dupr&rsn=inv`
  );

  url.searchParams.append('mf', moduleFor);
  url.searchParams.append('uid', userId);

  if (cancelUrl) url.searchParams.append('cancelurl', encodeURI(cancelUrl));
  if (successUrl) url.searchParams.append('successurl', encodeURI(successUrl));

  return url.toString();
};
